@if (address) {
  <address class="card">
    <div class="card-body">
      <h5 class="card-title">
        @if (address.salutation || customer().salutation) {
          <span>{{ address.salutation ? address.salutation : customer().salutation }} </span>
        }
        @if (address.title || customer().title) {
          <span>{{ address.title ? address.title : customer().title }} </span>
        }
        @if (address.firstname || customer().firstname) {
          <span>{{ address.firstname ? address.firstname : customer().firstname }} </span>
        }
        @if (address.lastname || customer().lastname) {
          <span>{{ address.lastname ? address.lastname : customer().lastname }}<br /></span>
        }
        @if (address.company) {
          <span>{{ address.company }}</span>
        }
      </h5>
      <p class="card-text">
        {{ address.street }}@if (address.houseNumber) {
        <span> {{ address.houseNumber }}</span>
        }<br />
        {{ address.postalcode }} {{ address.city }}<br />
        {{ address.country?.name }}<br />
        @if (address.telephone) {
          <span><br />Telefon: {{ address.telephone }}<br /></span>
        }
      </p>
      @if (showCrudControls) {
        <div class="buttons">
          <button class="btn btn-sm btn-red" (click)="emitDeleteAddress($event, address)">Löschen</button>
          <button class="btn btn-sm btn-green" (click)="editAddress($event, address)">Bearbeiten</button>
          <button class="btn btn-sm btn-green">Wählen</button>
        </div>
      }
    </div>
  </address>
}

